import { render, staticRenderFns } from "./BotonGuardar.vue?vue&type=template&id=4da5374f&scoped=true&"
import script from "./BotonGuardar.vue?vue&type=script&lang=js&"
export * from "./BotonGuardar.vue?vue&type=script&lang=js&"
import style0 from "./BotonGuardar.vue?vue&type=style&index=0&id=4da5374f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da5374f",
  null
  
)

export default component.exports